/**
 * @description 客户端交互方法
 */
/*eslint-disable*/
import {Base64} from 'js-base64'
import {isIOS} from "../utils";
// 如果没有这个方法的时候的回参
// {request_type='do_type_app_is_installed', request_callback_method='chenkAppIsInstalledCallback', result='SUCCESS', result_desc='接口正常', result_data='{"isInstalled":false}'}

function compareVersion(a, b) {
  if (!a) return false
  if (a === b) return true
  let vA = a.split('.');
  let vB = b.split('.');
  for (let i = 0; i < vA.length; ++i) {
    let a = parseInt(vA[i]);
    let b = parseInt(vB[i] || 0);
    if (a === b) {
      continue;
    } else {
      return a > b
    }
  }
  return false // 前面都相同，a位数小于b时，则a小
}

class ClientService {
  constructor() {
    this.clientType = /i(phone|pad|os)/g.test(navigator.userAgent.toLowerCase()) ? 'IOS' : 'ANDROID'
  }

  /**
   * 创建统一的回调函数，区分 android 和 ios
   * @param callback  function 回调函数
   * @returns {Function}
   * @private
   */
  _createCallBack(callback) {
    return (data) => {
      let _data = !!data
      if (this.clientType === 'ANDROID') {
        if (_data) {
          data = JSON.parse(data) // 安卓需要重新处理一下
        } else {
          data = {}
        }
      }
      callback && callback(data) // 执行回调
    }
  }

  /**
   * 创建请求的参数的公共函数
   * @param requestType string 请求的方式名，如 do_xxx
   * @param requestCallBack string 请求后的回调全局函数，如 xxxCallback
   * @param requestCallBackHaveParam boolean 请求后的回调函数是否有参 true|false
   * @param option Object 即 request_data, 请求所给的参数，可为空，须为 object，
   * @private
   */
  _createParams(requestType, requestCallBack, requestCallBackHaveParam, option = '') {
    let params = {
      'request_type': requestType,
      'request_callback_method': requestCallBack,
      'request_callback_have_param': this.clientType === 'IOS' ? requestCallBackHaveParam + '' : requestCallBackHaveParam // string|boolean
    }

    if (option) {
      params.request_data = this.clientType === 'IOS' ? option : JSON.stringify(option) // 安卓需要 stringify 一下
      // params.request_data = JSON.stringify(option)
    }
    return params
  }

  /**
   * 发送请求
   * @param params 发送到后台的参数系列，应通过 _createParams / _createCallBack 等生成
   * @returns {string|object} 安卓的回调*似乎*是同步的，但可能也是异步的，所以做此返回
   * @private
   */
  _doAction(params) {
    if (this.clientType === 'IOS') {
      window.webkit.messageHandlers.iOSFYDH.postMessage(params)
      return ''
    } else {
      let str = JSON.stringify(params)
      let result = window.JsManager.doSomethingByH5(str)
      return JSON.parse(result)
    }
  }

  /**
   * 唤起客户端支付
   * @param option {} 支付参数--
   * @param callback function 回调函数
   * @returns {*} data.result
   */
  pay(option = {}, callback) {
    try {
      let payStr = {}
      // 根据不同支付方式、按照客户端所需要的格式拼接参数
      if (option.payMethodCode === 'WXPAY') {
        payStr = JSON.parse(Base64.decode(option.payStr))
        payStr.PAY_METHOD_CODE = option.payMethodCode
      } else if (option.payMethodCode === 'CMBPAY') {
        payStr = JSON.parse(Base64.decode(option.payStr))
        payStr = Object.assign({}, payStr, {
          PAY_METHOD_CODE: option.payMethodCode
        })
      } else {
        payStr.PAY_QR_CODE = option.payStr
        payStr.PAY_METHOD_CODE = option.payMethodCode
      }
      window.paySdkCallback = this._createCallBack(callback)
      let params = this._createParams('do_type_paysdk', 'paySdkCallback', true, payStr)
      return this._doAction(params)
    } catch (e) {
      console.log(e.message)
    }
  }

  /**
   * 获取用户信息 callback 提示：LOGIN_TOKEN: data.token
   * @param option string|{} 参数
   * @param callback function 回调参数 <br>
   * return phoneNum/token/userBirthday/userNickName/userSex/shareMode/userID
   * @returns {}
   */
  getUserInfo(option = {}, callback) {
    try {
      window.userInfoCallback = this._createCallBack(callback)
      let params = this._createParams('do_type_user_info', 'userInfoCallback', true)
      return this._doAction(params)
    } catch (e) {
      return ''
    }
  }

  /**
   * 获取客户端信息，callback, 提示 CLIENT_VERSION_NO: data.clientVersionNo
   * @param option string|{} 参数
   * @param callback function 回调参数 <br>
   * return: clientVersionId/clientVersionNo/packageName/versionName/versionNum/API_SERVICE_VERSION/BRAND_CODE
   * @returns {*}
   */
  getClientInfo(option = {}, callback) {
    try {
      window.appInfoCallback = this._createCallBack(callback)
      let params = this._createParams('do_type_app_info', 'appInfoCallback', true)
      return this._doAction(params)
    } catch (e) {
      return ''
    }
  }

  /**
   * 客户端跳转到登录, callback 提示：window.location.reload()
   * @param option string|{} 参数
   * @param callback function 回调参数
   * @returns {*}
   */
  jumpToLogin(option = {}, callback) {
    try {
      window.JumpLoginCallback = this._createCallBack(callback)
      let params = this._createParams('do_type_jump_login', 'JumpLoginCallback', true)
      return this._doAction(params)
    } catch (e) {
      return ''
    }
  }

  /**
   * @public 分享
   * @param {Function} callback 成功回调
   * @param {Object} option {ShareInfoConfig: {
   * shareTitle: '',
    shareText: '',
    shareLongUrl: '', // 分享链接
    shareShortUrl: '', // 不传
    shareLogoUrl:'' }}
   */
  share(option = {}, callback) {
    try {
      window.shareCallback = this._createCallBack(callback)
      let params = this._createParams('do_type_share', 'shareCallback', true, option)
      return this._doAction(params)
    } catch (e) {
    }
  }

  jumpApp(versionName, options = {}, callback) {
    try {
      window.jumpAppCallback = this._createCallBack(callback)
      let newOptions = {}
      if ((compareVersion(versionName, '5.9.0') && !isIOS())
        || (compareVersion(versionName, '3.9.0') && isIOS())) { // 新版
        newOptions = options
      } else { // 旧版
        if (!isIOS()) {
          if (options.actionPars) {
            // h5跳转时，className没配所以写死一个默认，isLogin为false
            newOptions = {
              className: options.actionPars.androidClass || 'com.phone580.base.ui.activity.X5BrowserActivity',
              extendParam: options.actionPars,
              isLogin: !!(options.actionPars.androidClass)
            }
          }
        } else {
          newOptions = {
            extendParam: JSON.stringify(options)
          }
        }
      }
      let params = this._createParams('do_type_jumpApp', 'jumpAppCallback', true, newOptions)
      return this._doAction(params)
    } catch {
    }
  }
  // 判断是否安装某个APP
  chenkAppIsInstalled(versionName, options = {}, callback) {
    try {
      window.chenkAppIsInstalledCallback = this._createCallBack(callback)
      if ((compareVersion(versionName, '7.3.2') && !isIOS())
        || (compareVersion(versionName, '5.3.1') && isIOS())) { // 新版
        let params = this._createParams('do_type_app_is_installed', 'chenkAppIsInstalledCallback', true, options)
        return this._doAction(params)
      } else { // 旧版
        callback && callback()
      }
    } catch {
      // callback && callback()
    }
  }
  
}

export const clientService = new ClientService()
